import { createContext } from 'react';
import { DriverCheckInStateType, initialDriverCheckInState } from '../types/DriverCheckInState';

export const DriverCheckInContext = createContext<{
    state: DriverCheckInStateType; 
    dispatch: React.Dispatch<any>;
}>({
    state: initialDriverCheckInState, 
    dispatch: () => null
});